import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useAtom } from "jotai";
import Table from "./table";
import reportsAtoms, { fetchTrackerDataAtom, fetchPartsDataAtom } from "../../../atoms/reports/ReportsAtom";

const TableContainer = () => {
  const [reportsData] = useAtom(reportsAtoms);
  const [, fetchTrackerData] = useAtom(fetchTrackerDataAtom);
  const [, fetchPartsData] = useAtom(fetchPartsDataAtom);

  useEffect(() => {
    fetchTrackerData();
    fetchPartsData();
  }, [fetchTrackerData, fetchPartsData]);

  useEffect(() => {
  }, [reportsData]);

  return (
        <Box elevation={3} sx={{ p: 3 }}>
          <Typography sx={{ fontWeight: 600, fontSize: "20px", mb: 3 }}>
            Bill of Materials By Block
          </Typography>

          <Table
            trackerData={reportsData.trackerData || []}
            partsData={reportsData.partsData || []}
          />
        </Box>
  );
};

export default TableContainer;